import { Route, Routes } from 'react-router-dom';
import { ScrollToTop, SessionExpiredDialog } from '@ota/design-system';
import { authStore } from './api';
import { BookingDetailPage } from './pages/BookingDetailPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { HomePage } from './pages/HomePage';
import { ListingPage } from './pages/ListingPage';
import { LoginPage } from './pages/LoginPage';
import { MyBookingsPage } from './pages/MyBookingsPage';
import { MyProfilePage } from './pages/MyProfilePage';
import { Privacy } from './pages/Privacy';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { SignupPage } from './pages/SignupPage';
import { Support } from './pages/Support';

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hotels" element={<ListingPage />} />
        <Route path="/hotels/:id" element={<PropertyDetailPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/my-bookings" element={<MyBookingsPage />} />
        <Route path="/my-bookings/:id" element={<BookingDetailPage />} />
        <Route path="/my-profile" element={<MyProfilePage />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      {/* Global session-expired dialog — listens to api-client's shared
          store and replaces the previous immediate redirect-to-login. */}
      <SessionExpiredDialog authStore={authStore} />
    </>
  );
}
